// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__4qzSU","actionsCol":"EnrolledClinics_actionsCol__3vE4R"};